import "core-js/modules/es.array.reverse.js";
var _class, _CesiumIonSearchProvider;
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { makeObservable, override, runInAction } from "mobx";
import Rectangle from "terriajs-cesium/Source/Core/Rectangle";
import { Category, SearchAction } from "../../Core/AnalyticEvents/analyticEvents";
import loadJson from "../../Core/loadJson";
import { applyTranslationIfExists } from "../../Language/languageHelpers";
import LocationSearchProviderMixin from "../../ModelMixins/SearchProviders/LocationSearchProviderMixin";
import CesiumIonSearchProviderTraits from "../../Traits/SearchProviders/CesiumIonSearchProviderTraits";
import CreateModel from "../Definition/CreateModel";
import SearchResult from "./SearchResult";
import CommonStrata from "../Definition/CommonStrata";
let CesiumIonSearchProvider = (_class = (_CesiumIonSearchProvider = class CesiumIonSearchProvider extends LocationSearchProviderMixin(CreateModel(CesiumIonSearchProviderTraits)) {
  get type() {
    return CesiumIonSearchProvider.type;
  }
  constructor(uniqueId, terria) {
    super(uniqueId, terria);
    makeObservable(this);
    runInAction(() => {
      if (this.terria.configParameters.cesiumIonAccessToken) {
        this.setTrait(CommonStrata.defaults, "key", this.terria.configParameters.cesiumIonAccessToken);
      }
    });
  }
  showWarning() {
    if (!this.key || this.key === "") {
      console.warn("The ".concat(applyTranslationIfExists(this.name, i18next), "(").concat(this.type, ") geocoder will always return no results because a CesiumIon key has not been provided. Please get a CesiumIon key from ion.cesium.com, ensure it has geocoding permission and add it to searchProvider.key or parameters.cesiumIonAccessToken in config.json."));
    }
  }
  logEvent(searchText) {
    var _this$terria$analytic;
    (_this$terria$analytic = this.terria.analytics) === null || _this$terria$analytic === void 0 || _this$terria$analytic.logEvent(Category.search, SearchAction.cesium, searchText);
  }
  async doSearch(searchText, searchResults) {
    searchResults.results.length = 0;
    searchResults.message = undefined;
    let response;
    try {
      response = await loadJson("".concat(this.url, "?text=").concat(searchText, "&access_token=").concat(this.key));
    } catch (_e) {
      searchResults.message = {
        content: "translate#viewModels.searchErrorOccurred"
      };
      return;
    }
    runInAction(() => {
      if (!response.features || response.features.length === 0) {
        searchResults.message = {
          content: "translate#viewModels.searchNoLocations"
        };
        return;
      }
      searchResults.results = response.features.map(feature => {
        const [w, s, e, n] = feature.bbox;
        const rectangle = Rectangle.fromDegrees(w, s, e, n);
        return new SearchResult({
          name: feature.properties.label,
          clickAction: createZoomToFunction(this, rectangle),
          location: {
            latitude: (s + n) / 2,
            longitude: (e + w) / 2
          }
        });
      });
    });
  }
}, _defineProperty(_CesiumIonSearchProvider, "type", "cesium-ion-search-provider"), _CesiumIonSearchProvider), _applyDecoratedDescriptor(_class.prototype, "showWarning", [override], Object.getOwnPropertyDescriptor(_class.prototype, "showWarning"), _class.prototype), _class);
export { CesiumIonSearchProvider as default };
function createZoomToFunction(model, rectangle) {
  return function () {
    const terria = model.terria;
    terria.currentViewer.zoomTo(rectangle, model.flightDurationSeconds);
  };
}